export const TEST_STATUS = {
  PASSED: 'Passed',
  FAILED: 'Failed',
  EDITED: 'Edited',
  UNTESTED: 'Not Tested',
};
